import axios, { AxiosResponse } from 'axios';
import { con } from '../../../application/entity/Rutas';
import { IServiceResult } from '../../Interfaces/IServiceResult';
import { ServiceResult } from './ServiceResult';

export class SVCFacturacion {

    public static async ObtieneDocumentoPorAlumno(headers: any, rut: number, codigoNegocio: number, codigoPrograma: string,
        codigoPlanificacion: number, agno: number, periodo: number, idPeriodo: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRutaBFF();
        const url: string = _ruta + "GetFacturacionAlumnoProgramaPorRut";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .get(url, {
                headers,
                params: {
                    'iRut': rut,
                    'iCodigoNegocio': codigoNegocio,
                    'sCodigoPrograma': codigoPrograma,
                    'iCodigoPlanificacion': codigoPlanificacion,
                    'iAgno': agno,
                    'iPeriodo': periodo,
                    'iIdPeriodo': idPeriodo
                }
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });
        return sr;
    }

    public static async ObtieneDatosFacturacion(
        headers: any,
        RutFacturacion: string
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRutaBFF();
        const url: string = _ruta + 'GetFacturacionEmpresaContactoPorRut';
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = 'Inicializando invocación';

        await axios
            .get(url, {
                headers,
                params: {
                    'iRun': RutFacturacion,
                },
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });
        return sr;
    }


    public static async ObtieneDatosPersonales(
        RutFacturacion: string,
        headers: any
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRutaBFF();
        const url: string = _ruta + 'GetDatosPostulantesPorRut';
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = 'Inicializando invocación';

        await axios
            .get(url, {
                headers,
                params: {
                    'iRun': RutFacturacion,
                    'codigoNegocio': 0,
                    'tipoPersona': 0,
                    'idPeriodo': 0
                },
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });
        return sr;
    }
    //////////////////////////////////////////////////////////

    public static async GrabarFacturacion(
        IdProcesoPostulante: number,
        RutFacturacionSF: number,
        DV: string,
        Giro: string,
        RazonSocial: string,
        CorreoFacturacion: string,
        Telefono: string,
        Direccion: string,
        IDComuna: number,
        DatosAlumno: boolean
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + 'FacturacionEmpresaContacto/ActualizaGuardarFacturacionInfoMatricula';
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = 'Inicializando invocación';
        var data: any = {
            'ID_PROCESO': IdProcesoPostulante,
            'RUT_FACTURACION': RutFacturacionSF,
            'DV_RUT': DV,
            'GIRO': Giro,
            'RAZON_SOCIAL': RazonSocial,
            'MAIL_ENVIO_FACTURA': CorreoFacturacion,
            'TELEFONO': Telefono,
            'DIRECCION': Direccion,
            'ID_COMUNA': IDComuna,
            'Alumno': DatosAlumno,
            'FECHA_CREACION': new Date(),
            'FECHA_MODIFICACION': new Date(),
        }
        await axios
            .post(url, data,)
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });
        return sr;
    }


    public static async Get_FacturacionInfoMatricula(
        IdProcesoPostulante: number,
        RutFacturacion: number
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + 'FacturacionEmpresaContacto/GetFacturacionInfoMatricula';
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = 'Inicializando invocación';

        await axios
            .get(url, {
                params: {
                    'ID_PROCESO': IdProcesoPostulante,
                    'Rut': RutFacturacion,
                },
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });
        return sr;
    }

    public static async Del_FacturacionInfoMatricula(
        IdProcesoPostulante: number
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + 'FacturacionEmpresaContacto/EliminarFacturacionInfoMatricula?ID_PROCESO=' + IdProcesoPostulante;
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = 'Inicializando invocación';
        await axios
            .post(url)
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });
        return sr;
    }
}

